<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path
      d="M4.3 15.6C5.8 15.1 8.3 14.5 11 14.5C14.4 14.5 17 10.7 17 7.5V6.5C17 3.2 14.3 0.5 11 0.5C7.7 0.5 5 3.2 5 6.5V7.5C5 9.4 5.9 11.4 7.3 12.8C5.9 13 4.6 13.4 3.7 13.7C2.1 14.3 1 15.8 1 17.5V21.5C1 22.1 1.4 22.5 2 22.5H12C12.6 22.5 13 22.1 13 21.5C13 20.9 12.6 20.5 12 20.5H3V17.5C3 16.7 3.5 15.9 4.3 15.6ZM7 7.5V6.5C7 4.3 8.8 2.5 11 2.5C13.2 2.5 15 4.3 15 6.5V7.5C15 9.8 13.2 12.5 11 12.5C8.8 12.5 7 9.8 7 7.5Z"
    />
    <path
      d="M20.4 19.5L22.7 17.2C23.1 16.8 23.1 16.2 22.7 15.8C22.3 15.4 21.7 15.4 21.3 15.8L19 18.1L16.7 15.8C16.3 15.4 15.7 15.4 15.3 15.8C14.9 16.2 14.9 16.8 15.3 17.2L17.6 19.5L15.3 21.8C14.9 22.2 14.9 22.8 15.3 23.2C15.5 23.4 15.8 23.5 16 23.5C16.2 23.5 16.5 23.4 16.7 23.2L19 20.9L21.3 23.2C21.5 23.4 21.8 23.5 22 23.5C22.2 23.5 22.5 23.4 22.7 23.2C23.1 22.8 23.1 22.2 22.7 21.8L20.4 19.5Z"
    />
  </svg>
</template>
